import useTranslation from 'next-translate/useTranslation';

import { Box, LinkTranslatedStyledAsLink, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { EActionAttribute, EColor, ERouting, ETypographyVariant } from '@core/type';
import { EFAQCategory } from '@core/type/api';
import { FAQBlock } from '@core/widget';

import { ContactFaqProps } from '../interface-contact';

export const ContactFaq = ({ faqQuestions }: ContactFaqProps) => {
  const { isPhone } = useContextMediaQuery();
  const { t: tContact } = useTranslation(Translate.page.CONTACT);

  return (
    <Box margin={'0 auto 140px'} maxWidth={'764px'}>
      <Typography
        as={EActionAttribute.H2}
        variant={ETypographyVariant.H4}
        marginBottom={isPhone ? '24px' : '56px'}
        textAlign={'center'}
      >
        {tContact('faqTitle')}
      </Typography>

      <FAQBlock
        faqQuestions={faqQuestions}
        category={EFAQCategory.CONTACT}
        as={EActionAttribute.SECTION}
        maxWidth={'750px'}
        margin={'0'}
      />

      <Box
        textAlign={'center'}
        display={'flex'}
        justifyContent={'center'}
        flexDirection={isPhone ? 'column' : 'row'}
        marginTop={isPhone ? '30px' : '48px'}
      >
        <Typography marginRight={'4px'}>{tContact('moreAnswersHere')}</Typography>
        <Box>
          <LinkTranslatedStyledAsLink color={EColor.ACCENT} keyRoute={ERouting.FAQ}>
            {tContact('faqLink')}
          </LinkTranslatedStyledAsLink>
        </Box>
      </Box>
    </Box>
  );
};
